<div>
    <h1 mat-dialog-title>Riordina Giorni</h1>
    <span fxFlex></span>
    <button mat-icon-button aria-label="Chiudi" [mat-dialog-close] class="mat-dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content>

    <mat-list>
        <ng-container *ngFor="let day of this.days; index as index; last as last; first as first">
            <mat-list-item lines="3">
                <h4 mat-line>
                    <b>Giorno {{ getOldIndex(day) + 1 }}</b>
                    <br>
                    <ng-container *ngIf="index !== getOldIndex(day); else: e">
                        <small><i style="color: #00AAF1">diventa <b>Giorno {{ index + 1 }}</b></i></small>
                    </ng-container>
                    <ng-template #e>

                    </ng-template>
                </h4>
                <p mat-line>
                    <small>
                        {{ day.title }}
                    </small>
                </p>
                <div fxLayout="row">
                    <button mat-icon-button matTooltip="Sposta in alto" [disabled]="first"
                        (click)="moveTo(index, index-1)">
                        <mat-icon>arrow_upward</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Sposta in basso" [disabled]="last"
                        (click)="moveTo(index, index+1)">
                        <mat-icon>arrow_downward</mat-icon>
                    </button>
                </div>
            </mat-list-item>
            <mat-divider *ngIf="!last"></mat-divider>
        </ng-container>
    </mat-list>

</div>
<div mat-dialog-actions>
    <button mat-raised-button matDialogClose>
        Annulla
    </button>
    <span fxFlex></span>
    <button mat-raised-button color="primary" [matDialogClose]="days" cdkFocusInitial>
        Ok
    </button>
</div>